import { IHeaderAngularComp } from 'ag-grid-angular';
import { GridApi, IHeaderParams } from 'ag-grid-community';

import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PeriodColumnParams } from '@core/typings/period-column-params';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@portal-shared/app/components/base-components/base.component';
import { ResponsiveDirective } from '@portal-shared/app/directives/responsive.directive';
import { Period } from '@portal-shared/app/entities/period.model';
import { DateFormatPipe } from '@portal-shared/app/pipes/date-format.pipe';
import { LanguageService } from '@portal-shared/app/services/language.service';
import { PeriodService } from '@services/period.service';
import { PlanningBoardPeriodService } from '@services/planning-board-period.service';
import { DateTime } from 'luxon';

@Component({
    selector: 'al-period-header-cell-renderer',
    templateUrl: './period-header-cell-renderer.component.html',
    styleUrls: ['./period-header-cell-renderer.component.scss'],
    imports: [FontAwesomeModule, MatTooltipModule, DateFormatPipe, ResponsiveDirective, TranslateModule]
})
export class PeriodHeaderCellRendererComponent extends BaseComponent implements IHeaderAngularComp {
  public period?: Period;
  public isPast = false;
  public isCurrentPeriod = false;
  public isFirstPeriodColumn = false;
  public isLastPeriodColumn = false;
  public isBackToTodayShown = false;
  public isForwardToTodayShown = false;

  private gridApi?: GridApi;

  public constructor(
    private periodService: PeriodService,
    public langService: LanguageService,
    private planningBoardPeriodService: PlanningBoardPeriodService
  ) {
    super();
  }

  public refresh(): boolean {
    return false;
  }

  public async agInit(params: IHeaderParams & PeriodColumnParams) {
    this.gridApi = params.api;
    const now = DateTime.now();

    const currentPeriod = await this.periodService.getCurrentPeriod();

    this.subscribe(
      this.planningBoardPeriodService.observeVisiblePeriods().subscribe(periods => {
        this.period = periods[params.periodIndex];

        if (this.period) {
          this.isPast = this.period.endDate < now;
          this.isCurrentPeriod = this.period.isCurrentPeriod;

          this.isFirstPeriodColumn = params.periodIndex === 0;
          this.isLastPeriodColumn = params.periodIndex === periods.length - 1;

          this.isBackToTodayShown = this.isFirstPeriodColumn && this.period.startDate > currentPeriod.endDate;
          this.isForwardToTodayShown = this.isLastPeriodColumn && this.period.endDate < currentPeriod.startDate;
        }
      })
    );
  }

  public async nextPeriods() {
    this.gridApi?.stopEditing();
    await this.planningBoardPeriodService.navigateBy(1);
  }

  public async previousPeriods() {
    this.gridApi?.stopEditing();
    await this.planningBoardPeriodService.navigateBy(-1);
  }

  public async gotoToday() {
    this.gridApi?.stopEditing();
    await this.planningBoardPeriodService.navigateTo();
  }
}
